var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"report-data-area-box"},[_c('div',{staticClass:"report-data-area",attrs:{"id":_vm.canvasId}})])}
var staticRenderFns = []

export { render, staticRenderFns }